package de.ohhhmhhh.frontend.admin.ui.screens.user.subscriptions

data class UserSubscriptionState(
    val id: String? = null,
    val items: List<SubscriptionItem> = emptyList(),
    val success: String? = null
)